module.exports = __webpack_public_path__ + "media/clients/christine-2x-60d6ac80.jpg";